// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3ybN3","icon":"icon-1Vo9i","sunInfo__inner":"sunInfo__inner-1G4D8"};